import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-he_003",
  "use": "icon-he_003-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-he_003\"><defs><style>#icon-he_003 .cls-1{fill:none;opacity:0;}</style></defs><g id=\"icon-he_003_レイヤー_2\" data-name=\"レイヤー 2\"><g id=\"icon-he_003_icon\"><rect class=\"cls-1\" width=\"24\" height=\"24\" /><polygon class=\"cls-2\" points=\"12 16.77 5.82 21 8.03 13.89 2 9.02 9.55 9 12 2 14.45 9 22 9.02 15.97 13.89 18.18 21 12 16.77\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol